import React from 'react';
import { Data, Label, LabeledInformationWrapper } from '@Components/Card/cards/ShippingDetails/ShippingDetails.styled';

interface ILabeledInformation {
	data?: string | number;
	label: string;
}

const LabeledInformation = ({ label, data }: ILabeledInformation): JSX.Element => (
	<LabeledInformationWrapper>
		<Label>{label}</Label>
		<Data>{String(data || '')}</Data>
	</LabeledInformationWrapper>
);

export default LabeledInformation;
